import React, { FC, useState } from 'react'

import { LoadingDots, Typography } from '@smarty-nx/ds'
import cn from 'classnames'

import classes from './index.module.scss'
import PageHead from '../../components/PageHead'
import { SiteContainer } from '../../components/shared'
import withApp from '../../components/withApp/withApp'
import { CONFIG } from '../../config'

const CoverageCheckerApp: FC = () => {
  const [loaded, setLoaded] = useState(false)

  return (
    <SiteContainer className={classes.siteContainer}>
      {!loaded && (
        <div className={classes.loadingState}>
          <LoadingDots className={classes.loadingDotsWidth} />
          <Typography variant="Kollektif/Small">
            Loading coverage map
          </Typography>
        </div>
      )}
      <div
        className={cn(classes.iframeContent, {
          [classes.iframeContentVisible]: loaded,
        })}
      >
        <iframe
          title="coverage-checker-app"
          src={CONFIG.NETWORK_COVERAGE_CHECKER_LINK}
          height="700"
          onLoad={() => setLoaded(true)}
          data-testid="coverage-checker-iframe-app"
          style={{
            width: '100%',
            border: 'none',
            background: 'white',
          }}
        />
      </div>
    </SiteContainer>
  )
}

export default withApp(CoverageCheckerApp)

export const Head = ({ location }: { location: { pathname: string } }) => (
  <PageHead
    title="Coverage checker"
    description="SMARTY is a new SIM-only mobile network that's built to be fair, transparent and smart."
    location={location}
  >
    <meta name="robots" content="noindex, nofollow" />
  </PageHead>
)
